import React from "react";
import { Redirect } from "react-router-dom";
import { useQuery } from "@apollo/client";
import gql from "graphql-tag";

// Components
import Loader from "../Loader/Loader";
import LanguageItem from "./LanguageItem";

// Utils
import { GET_LANGUAGES } from "../../queries/Language.queries";

// Types
import { Language as ILanguage } from "../../types/Language.types";

// Styles
import LoginIllustration from "../../static/images/login-illustration.svg";
import SonnenLogo from "../../static/images/logo-sonnen-white.svg";
import "./Language.scss";
import { LOCAL_STORAGE_LANGUAGE_CODE } from "../../constants/LocalStorage";

const QUERY_LANGUAGE_LIST = gql`
  ${GET_LANGUAGES}
`;

const Language: React.FC = () => {
  const [languages, setLanguages] = React.useState<ILanguage[]>([]);
  const [countryCode, setCountryCode] = React.useState<string | null>(null);

  const { loading } = useQuery(QUERY_LANGUAGE_LIST, {
    onCompleted: (data) => {
      const { languages: dataLanguages } =
        data.spracheinstellungen.translationSettings;

      setLanguages(dataLanguages);
    },
  });

  React.useEffect(() => {
    const countryCodeFromLocalStorage = localStorage.getItem(
      LOCAL_STORAGE_LANGUAGE_CODE
    );
    if (countryCodeFromLocalStorage) {
      setCountryCode(countryCodeFromLocalStorage);
    }
  }, []);

  if (countryCode) {
    return <Redirect to={`/${countryCode}/login`} />;
  }

  return (
    <div className="language">
      <div className="language-container">
        <div className="language-container__inner">
          <div className="language-container__header">
            <img src={SonnenLogo} alt="sonnen" />
          </div>
          <div className="language-container__intro">
            <div className="language-container__intro__illustration">
              <img src={LoginIllustration} alt="Login" />
            </div>
            <h1>To continue please pick a language</h1>
          </div>
          {loading && <Loader />}
          <ul>
            {!loading &&
              languages &&
              languages.map((language) => (
                <LanguageItem key={language.countryCode} {...language} />
              ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Language;
